import { Link } from 'react-router-dom';
import Avatar from '../../profile/ui/Avatar';
import { waitingLabel } from '../../../lib/relativeTime';

const SHOWN = 2;

export default function ToApproveCard({ rows }) {
  if (!rows || rows.length === 0) return null;
  const extra = rows.length - SHOWN;
  return (
    <section className="home-card" aria-labelledby="home-approve-h">
      <h2 id="home-approve-h" className="home-card__title">To approve</h2>
      <ul className="home-list">
        {rows.slice(0, SHOWN).map((r) => (
          <li key={r.id} className="home-row">
            <Avatar name={r.requester_name} size="node" variant="hashed" />
            <span className="home-row__text">
              <span className="home-row__title" title={`${r.name}, proposed by ${r.requester_name}`}>{r.name}, proposed by {r.requester_name}</span>
              <span className="home-row__detail">{waitingLabel(r.created_at)}</span>
            </span>
            <Link className="btn btn-primary btn-small" to="/requests#sub=approve">Review</Link>
          </li>
        ))}
      </ul>
      {extra > 0 && <Link className="home-link" to="/requests#sub=approve">+{extra} more</Link>}
    </section>
  );
}
